import React from 'react';
import Logo from './Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faFacebookF, faInstagram, faLinkedin} from '@fortawesome/free-brands-svg-icons';
import { Link, useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const location = useLocation();
  return (
    <footer className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-100 pb-[env(safe-area-inset-bottom)]">
      <div className="px-3 py-2 sm:px-4 sm:py-3 md:py-4">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-3 md:gap-4">
          {/* Quick Links + Follow Us */}
          <div className="flex flex-wrap items-center justify-center gap-x-2 sm:gap-x-4 gap-y-1 order-1 sm:order-2">
            {/* Quick Links - Hide labels on very small screens */}
            <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3">
              <span className="text-[10px] sm:text-xs text-gray-400 hidden md:inline">Quick Link</span>
              <a
                href="https://www.nextpangaea.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors">
                NextPangaea
              </a>
              <a
                href="https://cosvisor.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors">
                Cosvisor
              </a>
              <a
                href="https://enuva.co.kr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors hidden xs:inline">
                eNUVA
              </a>
              <a
                href="https://sponuva.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors hidden sm:inline">
                <i>SPONUVA</i>
              </a>
            </div>

            {/* Divider */}
            <span className="hidden lg:inline text-gray-300">|</span>

            {/* Legal Links */}
            <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3">
              <span className="text-[10px] sm:text-xs text-gray-400 hidden md:inline">Legal</span>
              <Link
                to="/terms"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors">
                Terms
              </Link>
              <Link
                to="/privacy"
                className="text-[10px] sm:text-xs text-gray-600 hover:text-np-600 transition-colors">
                Privacy
              </Link>
            </div>

            {/* Divider */}
            <span className="hidden lg:inline text-gray-300">|</span>

            {/* Follow Us */}
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-[10px] sm:text-xs text-gray-400 hidden md:inline">Follow Us</span>
              <a
                href="https://linkedin.com/company/nextpangaea"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-np-600 transition-colors">
                <FontAwesomeIcon icon={faLinkedin} className="w-3 h-3 sm:w-4 sm:h-4" />
              </a>
              <a
                href="https://instagram.com/nextpangaea"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-np-600 transition-colors">
                <FontAwesomeIcon icon={faInstagram} className="w-3 h-3 sm:w-4 sm:h-4" />
              </a>
              <a
                href="https://facebook.com/nextpangaea"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-np-600 transition-colors">
                <FontAwesomeIcon icon={faFacebookF} className="w-3 h-3 sm:w-4 sm:h-4" />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-[10px] sm:text-xs text-gray-400 order-2 sm:order-1 whitespace-nowrap">
            © 2021 NextPangaea Inc.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;